import { createContext } from "react";

export const Breakpoints = createContext();
